import type { PropType } from 'virtual-vue';
import type { SwipeAction, SwipeCellProps, SwipeCellState } from './swipe-cell';

/** 默认判定展开的位移比例 */
export const DEFAULT_SWIPE_THRESHOLD = 0.25;

/**
 * 组件的props
 */
export const props = {
  /**
   * 当前展开状态（Vue3 v-model）
   * @default 'closed'
   */
  modelValue: {
    type: String as PropType<SwipeCellState>,
    default: 'closed',
  },
  /**
   * 当前展开状态（Vue2 v-model）
   * @default 'closed'
   */
  value: {
    type: String as PropType<SwipeCellState>,
    default: 'closed',
  },
  /**
   * 标识符，用于事件回传与多实例区分
   */
  name: {
    type: [String, Number] as PropType<string | number>,
    default: undefined,
  },
  /**
   * 右侧操作配置（左滑展示）
   * @default []
   */
  actions: {
    type: Array as PropType<SwipeAction[]>,
    default: () => [],
  },
  /**
   * 是否禁用滑动
   * @default false
   */
  disabled: {
    type: Boolean,
    default: false,
  },
  /**
   * 点击操作按钮后自动收起
   * @default true
   */
  closeOnClickAction: {
    type: Boolean,
    default: true,
  },
  /**
   * 点击内容区（单元格）时自动收起
   * @default true
   */
  closeOnClickCell: {
    type: Boolean,
    default: true,
  },
  /**
   * 判定展开的位移比例（操作区宽度的占比）
   * @default 0.25
   */
  threshold: {
    type: Number,
    default: DEFAULT_SWIPE_THRESHOLD,
  },
  /**
   * 关闭 / 操作前拦截，返回 false 或 reject 阻止
   */
  beforeClose: {
    type: Function as PropType<SwipeCellProps['beforeClose']>,
    default: undefined,
  },
};
